// extracted by mini-css-extract-plugin
export default {"root":"Submit_root__Nj6++","container":"Submit_container__FyhUq","subSpan":"Submit_subSpan__4MV6b"};